// extracted by mini-css-extract-plugin
module.exports = {"description":"_2Uy9xRCETt2vljmxfFT-2D","pageHeader":"VjAbaNr7T3hBnFlf_WjmB","icon":"_3QHo6ECxvfbWzgIy_gOldQ","table":"_3HuvkbIfHJJ1Um-9ccmTH5"};